module.exports = __webpack_public_path__ + "media/images/client/logo_HM_white-type@3x-d800adee5a29e18b0efe17fb6154b716.png";